import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { XpoShellModule } from '@xpo-ltl/ngx-ltl-core/shell';
import { XpoFooterModule } from '@xpo-ltl/ngx-ltl-core/footer';
import { XpoLtlAuthUiModule } from '@xpo-ltl/ngx-auth-ui';
import { XPO_AUTH_CONFIG, XpoAuthConfig } from '@xpo/ngx-auth';
import { XpoLtlAuthConfigLoaderService, XpoLtlAuthModule } from '@xpo-ltl/ngx-auth';
import { AngularFireModule } from '@angular/fire/compat';
import { environment } from '../environments/environment';
import { CONFIG_MANAGER_SERVICE_CONFIGURATION, ConfigManagerModule } from '@xpo-ltl/config-manager';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { DataApiModule, DataApiService, NotificationService } from '@xpo-ltl/data-api';
import { PickupRequestComponent, PickupRequestSnackbar } from './pickup-request/pickup-request.component';
import { XpoSnackBar } from '@xpo-ltl/ngx-ltl-core/snack-bar';
import { XpoCardModule } from '@xpo-ltl/ngx-ltl-core/card';
import { NgxLtlPickupRequestModule } from '@xpo-ltl/ngx-ltl-pickup-request';
import { SdkLocationModule } from '@xpo-ltl-2.0/sdk-location';
import { LocationApiService } from '@xpo-ltl/sdk-location';

import { AppMetadataApiService } from '@xpo-ltl-2.0/sdk-appmetadata';
import { CustomerApiService } from '@xpo-ltl-2.0/sdk-customer';
import { PickupRequestV2ApiService } from '@xpo-ltl-2.0/sdk-pickuprequestv2';
import { ShipmentApiService } from '@xpo-ltl-2.0/sdk-shipment';
import { CityOperationsApiService } from '@xpo-ltl/sdk-cityoperations';
import { DockOperationsApiService } from '@xpo-ltl/sdk-dockoperations';
import { GeoLocationApiService } from '@xpo-ltl/sdk-geolocation';
import { PickupRequestApiService } from '@xpo-ltl/sdk-pickuprequest';
import { ShipmentOdsApiService } from '@xpo-ltl/sdk-shipmentods';
import { ShipmentTrackingApiService } from '@xpo-ltl/sdk-shipmenttracking';
import { XpoLtlShipmentDetailModule } from '@xpo-ltl/ngx-ltl-shipment-details';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { ShipmentDetailsComponent } from './shipment-details/shipment-details.component';
import { XpoButtonModule } from '@xpo-ltl/ngx-ltl-core/button';
import { XpoConfirmDialogModule } from '@xpo-ltl/ngx-ltl-core/confirm-dialog';
import { XpoDialogModule } from '@xpo-ltl/ngx-ltl-core/dialog';
import { XpoIconModule } from '@xpo-ltl/ngx-ltl-core/icon';
import { XpoLtlEmailService, XpoLtlPipeModule, XpoLtlUpdateShipmentStatusModule } from '@xpo-ltl/ngx-ltl';
import { InfrastructureApiService } from '@xpo-ltl/sdk-infrastructure';
import { DocumentManagementApiService } from '@xpo-ltl/sdk-documentmanagement';
import { AgmCoreModule } from '@agm/core';
import { UpdateShipmentStatusComponent } from './update-shipment-status/update-shipment-status.component';

export function authConfigFactory(configService: XpoLtlAuthConfigLoaderService): XpoAuthConfig {
  configService.initSettings('./assets/config.json');

  return new XpoAuthConfig({
    appCode: configService.appCode,
    scopes: configService.scopes,
    isProd: configService.isProd,
    applicationRootUri: configService.appRootUri,
  });
}

const pipes = [DecimalPipe, DatePipe];

@NgModule({
  declarations: [AppComponent, PickupRequestComponent, ShipmentDetailsComponent, UpdateShipmentStatusComponent],
  imports: [
    AngularFireModule.initializeApp(environment.firebase),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAbZwcWqCI3-L4iwdagPYe1t44Dw_f91uk',
    }),
    XpoLtlAuthModule.forRoot({
      provide: XPO_AUTH_CONFIG,
      useFactory: authConfigFactory,
      deps: [XpoLtlAuthConfigLoaderService],
    }),

    CommonModule,
    XpoDialogModule,
    XpoShellModule,
    XpoButtonModule,
    XpoLtlAuthModule,
    XpoIconModule,
    XpoConfirmDialogModule,
    XpoLtlPipeModule,
    ConfigManagerModule,
    DataApiModule,
    BrowserModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    XpoShellModule,
    XpoFooterModule,
    XpoCardModule,
    XpoLtlAuthUiModule,
    AppRoutingModule,
    SdkLocationModule,
    NgxLtlPickupRequestModule,
    XpoLtlShipmentDetailModule,
    XpoLtlUpdateShipmentStatusModule,
  ],
  providers: [
    {
      provide: CONFIG_MANAGER_SERVICE_CONFIGURATION,
      useValue: { configFileUrl: './assets/config.json' },
    },
    LocationApiService,
    DataApiService,
    NotificationService,
    PickupRequestApiService,
    PickupRequestV2ApiService,
    CustomerApiService,
    ShipmentApiService,
    AppMetadataApiService,
    CityOperationsApiService,
    DockOperationsApiService,
    ShipmentTrackingApiService,
    ShipmentOdsApiService,
    GeoLocationApiService,
    // Root-level so dialogs opened by ngx-ltl-pickup-request (e.g. Cancel Pickup) share the capturing snackbar.
    PickupRequestSnackbar,
    { provide: XpoSnackBar, useExisting: PickupRequestSnackbar },
    InfrastructureApiService,
    XpoLtlEmailService,
    DocumentManagementApiService,
    pipes,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
